import React from "react";
import img1 from "../../../Assets/AboutUsImg/img1.svg";
import img2 from "../../../Assets/AboutUsImg/img2.svg";

const OurVision = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 py-10 lg:py-16">
      <div className="pointer-events-none absolute inset-0 opacity-40">
        <div className="absolute -left-24 top-0 h-72 w-72 rounded-full bg-[#064585]/40 blur-3xl" />
        <div className="absolute -right-24 bottom-0 h-72 w-72 rounded-full bg-[#5989C8]/30 blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 lg:px-8">
        <div
          className="text-center mb-8 md:mb-12"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <p className="inline-flex items-center justify-center px-4 py-1 rounded-full bg-white/5 border border-white/10 text-xs sm:text-sm text-[#5989C8] font-medium backdrop-blur-md">
            Why Web_Bocket Classes
          </p>
          <h2 className="mt-4 text-2xl md:text-3xl lg:text-4xl font-bold text-white tracking-wide">
            Our Mission & Vision
          </h2>
          <p className="mt-3 text-sm md:text-base text-slate-300/90 max-w-2xl mx-auto">
            We are dedicated to empowering aspiring software professionals with
            real-world skills, guided learning, and a clear roadmap to a
            successful tech career.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {/* Mission */}
          <div
            className="group relative rounded-3xl bg-white/5 border border-white/10 backdrop-blur-md p-6 lg:p-7 shadow-xl shadow-slate-950/40 hover:-translate-y-1 hover:border-[#5989C8]/70 transition-all duration-200"
            data-aos="fade-up-right"
          >
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-[#064585]/25 via-transparent to-[#5989C8]/10 opacity-0 group-hover:opacity-100 blur-xl transition-opacity duration-200" />

            <div className="relative flex items-center justify-center md:justify-start mb-4">
              <div className="inline-flex items-center justify-center rounded-2xl bg-slate-900/60 border border-white/10 p-3">
                <img src={img1} alt="Our Mission" className="h-10 w-10" />
              </div>
            </div>

            <div className="relative space-y-3">
              <h3 className="text-xl lg:text-2xl font-semibold text-white">
                Our Mission
              </h3>
              <p className="text-sm md:text-base text-slate-300/90 leading-relaxed">
                Our mission at Web_Bocket Classes is to{" "}
                <span className="text-slate-100 font-medium">
                  empower aspiring software professionals
                </span>{" "}
                by providing cutting-edge technical education, hands-on training
                with real-world projects, and{" "}
                <span className="text-slate-100 font-medium">
                  comprehensive career placement support
                </span>
                .
              </p>
            </div>
          </div>

          {/* Vision */}
          <div
            className="group relative rounded-3xl bg-white/5 border border-white/10 backdrop-blur-md p-6 lg:p-7 shadow-xl shadow-slate-950/40 hover:-translate-y-1 hover:border-[#5989C8]/70 transition-all duration-200"
            data-aos="fade-up-left"
          >
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-[#5989C8]/25 via-transparent to-[#064585]/10 opacity-0 group-hover:opacity-100 blur-xl transition-opacity duration-200" />

            <div className="relative flex items-center justify-center md:justify-start mb-4">
              <div className="inline-flex items-center justify-center rounded-2xl bg-slate-900/60 border border-white/10 p-3">
                <img src={img2} alt="Our Vision" className="h-10 w-10" />
              </div>
            </div>

            <div className="relative space-y-3">
              <h3 className="text-xl lg:text-2xl font-semibold text-white">
                Our Vision
              </h3>
              <p className="text-sm md:text-base text-slate-300/90 leading-relaxed">
                Our vision is to become a{" "}
                <span className="text-slate-100 font-medium">
                  leading institution in tech education
                </span>
                , renowned for our role in{" "}
                <span className="text-slate-100 font-medium">
                  shaping career-ready software engineers
                </span>{" "}
                through practical learning, mentorship, and industry-aligned
                programs.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurVision;
